import { http } from '@/lib/http';

const BASE = '/api/v1/tenancy/me/returns-settings';

export interface ReturnsSettings {
  /**
   * When true, a return settles (refund issued / exchange replacement
   * created) the moment the carrier confirms the reverse pickup —
   * instead of waiting for the goods to physically arrive and pass QC.
   * For tenants on slow or unreliable international reverse logistics.
   */
  settleReturnsOnPickup: boolean;
}

export type UpdateReturnsSettingsPayload = ReturnsSettings;

export const returnsSettingsService = {
  get: () => http.get<ReturnsSettings>(BASE),
  update: (payload: UpdateReturnsSettingsPayload) =>
    http.patch<ReturnsSettings, UpdateReturnsSettingsPayload>(BASE, payload),
};
